import styled from 'styled-components';

export const TipsWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 64px;
`;

export const TipsContent = styled.div`
    width: 622px;
    max-width: 100%;
    display: flex;
    flex-direction: column;
`;

export const TipsCardsWrapper = styled.div`
    margin-bottom: 40px;
`;

export const TipsHeader = styled.div`
    text-align: center;
    margin-bottom: 24px;
`;
